class DateClass {
  formingDate (val: string|number) {
    let stringVal = val.toString()
    const y = stringVal.slice(0, 4)
    const m = stringVal.slice(4, 6)
    const d = stringVal.slice(6, 8)
    stringVal = `${y}-${m}-${d}T00:00:00`

    let date = new Date(stringVal)
    return date
  }

  displayData (val: number) {
    let displayDate = this.formingDate(val).getMonth() + 1 + '月' + this.formingDate(val).getDate() + '日'
    return displayDate
  }

  setWeek (val: number) {
    const week = ['日', '月', '火', '水', '木', '金', '土']
    const weekDay = this.formingDate(val).getDay()

    return week[weekDay]
  }

  /* 月・日を二桁表示(0あり) */
  toDoubleDigits (val: number) {
    var data = val.toString()
    data += ''
    if (data.length === 1) {
      data = '0' + data
    }
    return data
  }

  /* 作付け日から収穫適期(最高)までの日数計算 */
  daysCalculation (date1: number, date2: number) {
    var day1 = this.formingDate(date1)
    var day2 = this.formingDate(date2)
    let days = (day2.getTime() - day1.getTime()) / (1000 * 60 * 60 * 24)

    return days
  }
}

export default new DateClass()
